export default {
  // 用户重复登录 or 登录失效
  NOT_LOGIN: 990003,
  // 本地没有token
  NO_TOKEN: 15003,
  // 获取店铺信息失败 获取店铺或者商户信息失败  权限系统获取店铺列表失败
  GET_SHOP_INFO_FAILED: [60008, 11020, 13017],
  // 无关联门店 或 没有权限 只有在登录相关接口会是无关联门店原因，要处理
  NO_RELEATED_SHOPS: 13023,
  // 菜品已是下架or下架状态
  ITEM_STATUS_HAS_UPDATED: [10031, 10032],
  WINE_QUALIFICATION_STATUS: [10310, 10311],
  // 上线检查未通过，无法开店，此时需要弹出上线检查弹窗
  SHOP_OPEN_FAILED: 11040,
  // 切换上线状态时，门店所在区域尚未开城，需要弹出未开通城市窗
  SHOP_AREA_NOT_LIMIT: 11037,
  // 菜品价格管控拦截
  FOOD_PRICE_CONTROL: 10043
}
